import { defineComponent as _defineComponent } from 'vue';
import Dropdown from "../dropdown/Dropdown.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContextMenu',
    props: {
        options: { type: Array, required: true },
        placement: { type: String, required: false, default: "bottom-start" },
        disabled: { type: Boolean, required: false, default: false },
        closeOnSelect: { type: Boolean, required: false, default: true }
    },
    emits: ["select", "open", "close"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const handleOptionClick = (option, close) => {
            if (option.disabled)
                return;
            emit("select", option);
            if (props.closeOnSelect) {
                close();
            }
        };
        const __returned__ = { props, emit, handleOptionClick, Dropdown };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
